 const getAvatar = (client) => {
    const {firstName, lastName} = client;
    if (client.profilePhotoURL) {
      return client.profilePhotoURL;
    }
    return null;
}

  const getInitials = ({ firstName, lastName, bgColor, txtColor, size }) => {
    const initials = `${firstName.charAt(0).toUpperCase()}${lastName.charAt(0).toUpperCase()}`;
    const _bgColor = bgColor.replace(/\/#/g, ''); // remove the hash if there is one
    const _txtColor = txtColor.replace(/\/#/g, ''); // remove the hash if there is one
    const _size = size.replace(/\/px/g, ''); // remove the px if included
    
    return `https://dummyimage.com/${_size}/${_bgColor}/${_txtColor}&text=${initials}`; 
  }

  export const getInitialsString = (string1, string2) => {
    return `${string1.charAt(0).toUpperCase()}${string2.charAt(0).toUpperCase()}`;
  }

  export default getAvatar;


// WEBPACK FOOTER //
// ./src/js/utils/avatarUtils.js